exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width: 0px) and (max-width: 991px) {\n.gx-custom-registration {\n    padding: 0 !important;\n}\n.gx-custom-registration .ant-input {\n      line-height: 2;\n      padding: 12px 18px !important;\n      font-size: 18px;\n      margin-bottom: 18px;\n}\n.gx-custom-registration .ant-form-item-label {\n      margin-bottom: 8px;\n}\n.gx-custom-registration .ant-form-item-label > label {\n      font-size: 18px;\n}\n.gx-custom-registration .ant-btn {\n      padding: 16px 42px !important;\n      line-height: 2;\n      width: 100%;\n}\n}\n", ""]);

// exports
